import { clearAllCookies } from "./cookie-utils";
import { navigateToClientPage } from "./navigation-utils";

export { getLoginSecured } from "./api";

export const createSessionForExternal = async (url) =>
  navigateToClientPage(url);

export const deleteAllCookies = () => {
  clearAllCookies();
};

export const formatDate = (dateString) => {
  if (!dateString || dateString === "0001-01-01T00:00:00") {
    return "N/A"; // Return a default value for invalid dates
  }

  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB"); // Format as DD/MM/YYYY
};
